import { Injectable, Injector } from '@angular/core';
import { BitfApiService } from '@bitf/services/api/bitf-api.service';
// import { IBitfApiRequest } from '@common/interfaces';

@Injectable({
  providedIn: 'root',
})
export class PublicBundlesService extends BitfApiService {
  constructor(public injector: Injector) {
    super('public-bundles', injector);
  }

  // getProjectDetails(requestParams: IBitfApiRequest) {
  //   return this.getById({
  //     populate: {
  //       expense_files: {
  //         populate: {
  //           expense_file_versions: {
  //             populate: {
  //               macrosections: {
  //                 populate: {
  //                   expense_items: {
  //                     sort: ['order:asc'],
  //                     populate: {
  //                       tasks: '*',
  //                       notes: '*',
  //                     },
  //                   },
  //                   project: '*',
  //                   expense_file_version: '*',
  //                 },
  //               },
  //             },
  //           },
  //         },
  //       },
  //       province: '*',
  //       account: '*',
  //       project_managers: '*',
  //       responsibles_project_managers: '*',
  //       marketing_strategiests: '*',
  //       graphic_designers: '*',
  //       project_manager: '*',
  //       tasks: '*',
  //     },
  //     ...requestParams,
  //   });
  // }
}
